/* eslint-disable no-prototype-builtins */

/**
 * Return all Google map style options for a custom look
 *
 * Google has a styling wizard https://mapstyle.withgoogle.com/ that can export these JSON-styles.
 *
 * @return {object} map styles
 */
function getMapStyles() {
  return {
    zoom: 12,
    maxZoom: 12,
    disableDefaultUI: true,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    scrollwheel: false,
    draggable: !('ontouchend' in document),
  };
}

module.exports = {
  getMapStyles,
  APIKEY: 'AIzaSyCohnNxkJE1F50QkNV4hyQXfs6ZDLgtkO8',
};
